import React, {
    useEffect,
    useState
} from 'react';
import {
    Navigate
} from 'react-router-dom';
import {
    verifyToken
} from '../../utils/verifyToken';

const ProtectedRoute = ({children}) => {
    const [isValid, setIsValid] = useState(null);

    useEffect(() => {
        (async () => {
            const valid = await verifyToken();
            setIsValid(valid);
        })();
    }, []);

    if (isValid === null) return <div>Loading...</div>;
    if (!isValid) return <Navigate
        to="/authentication/sign-in"
        replace/>;
    return children;
};

export default ProtectedRoute;
